export const plans = [
  {
    planName: "Βασική",
    smallName: 'Βασική',
    expiryDate: "30.06.2022",
    items: [
      {
        id: 1,
        title: "1 θέση εργασίας",
        description: "Δημοσιεύστε 1 θέση εργασίας το μήνα",
        fullPrice: 49,
        price: 25,
      },
      {
        id: 2,
        title: "3 θέσεις εργασίας",
        description: "Δημοσιεύστε 3 θέσεις εργασίας το μήνα",
        fullPrice: 99,
        price: 50,
      },
      {
        id: 3,
        title: "10 θέσεις εργασίας",
        description: "Δημοσιεύστε 10 θέσεις εργασίας το μήνα",
        fullPrice: 249,
        price: 125,
      },
      {
        id: 4,
        title: "Βάση δεδομένων βιογραφικών",
        description:
          "Πρόσβαση στη βάση δεδομένων βιογραφικών",
        fullPrice: 249,
        price: 125,
      },
    ],
  },
  {
    planName: "Συνδυασμός για 1 μήνα",
    smallName: '1 μήνα',
    expiryDate: "30.06.2022",
    items: [
      {
        id: 5,
        title: "1 θέση εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών",
        fullPrice: 249,
        price: 125,
      },
      {
        id: 6,
        title: "3 θέσεις εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών",
        fullPrice: 299,
        price: 150,
      },
      {
        id: 7,
        title: "10 θέσεις εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών",
        fullPrice: 449,
        price: 225,
      },
    ],
  },
  {
    planName: "Συνδυασμός για 3 μήνες",
    smallName: '3 μήνες',
    expiryDate: "30.06.2022",
    items: [
      {
        id: 8,
        title: "1 θέση εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών κάθε μήνα",
        fullPrice: 649,
        price: 325,
      },
      {
        id: 9,
        title: "3 θέσεις εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών κάθε μήνα",
        fullPrice: 749,
        price: 375,
      },
      {
        id: 10,
        title: "Συνδρομή: 10 θέσεις εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών κάθε μήνα",
        fullPrice: 1049,
        price: 525,
      },
    ],
  },
  {
    planName: "Συνδυασμός για 6 μήνες",
    smallName: '6 μήνες',
    expiryDate: "30.06.2022",
    items: [
      {
        id: 11,
        title: "1 θέση εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών κάθε μήνα",
        fullPrice: 799,
        price: 400,
      },
      {
        id: 12,
        title: "3 θέσεις εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών κάθε μήνα",
        fullPrice: 949,
        price: 475,
      },
      {
        id: 13,
        title: "10 θέσεις εργασίας + Πρόσβαση στη βάση δεδομένων βιογραφικών κάθε μήνα",
        fullPrice: 1349,
        price: 675,
      },
    ],
  },
];
